import { defineComponent, ref, computed } from "vue";

export default defineComponent({
  name: "FlashApp",

  props: {
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
    sizes: { type: String, default: "width: 48px; height: 48px;" },
    textLoading: { type: String, default: "onboardProcessing" },
  },

  setup(props) {
    const className = ref(props.class);
    const styleName = ref(props.style);
    document.title = "Processing...";
    const mode = localStorage.getItem("applicationMode") || "light-mode";
    const lang = localStorage.getItem("localization") || "en";

    const isLoading = computed(() => {
      return props.loading;
    });

    return {
      className,
      styleName,
      isLoading,
      mode,
      lang,
    };
  },
});
